/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./PushScheduledPrescriptionDialog.vue?vue&type=template&id=fb960ff8"
import script from "./PushScheduledPrescriptionDialog.vue?vue&type=script&lang=js"
export * from "./PushScheduledPrescriptionDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fb960ff8')) {
      api.createRecord('fb960ff8', component.options)
    } else {
      api.reload('fb960ff8', component.options)
    }
    module.hot.accept("./PushScheduledPrescriptionDialog.vue?vue&type=template&id=fb960ff8", function () {
      api.rerender('fb960ff8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/patients/PushScheduledPrescriptionDialog.vue"
export default component.exports